import React, { useState } from 'react';
import { TextField, Button, Grid, Paper, Typography } from '@mui/material';

const LoanForm = ({ onAddItem }) => {
  const [debtorName, setDebtorName] = useState('');
  const [description, setDescription] = useState('');
  const [principalAmount, setPrincipalAmount] = useState('');
  const [interestRate, setInterestRate] = useState('');
  const [dueDate, setDueDate] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!debtorName || !principalAmount || !interestRate || !dueDate) return;

    const principal = parseFloat(principalAmount);
    const rate = parseFloat(interestRate);

    // Lógica de cálculo de juros simples
    const totalWithInterest = principal * (1 + (rate / 100));

    const newItem = {
      debtor_name: debtorName,
      description: description,
      principal_amount: principal,
      interest_rate: rate,
      total_with_interest: totalWithInterest,
      due_date: dueDate,
    };
    
    onAddItem(newItem);

    // Limpa o formulário
    setDebtorName('');
    setDescription('');
    setPrincipalAmount('');
    setInterestRate('');
    setDueDate('');
  };

  return (
    <Paper sx={{ p: 3, mb: 3, boxShadow: 3 }}>
      <Typography variant="h6" gutterBottom>Registrar Novo Empréstimo</Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField label="Para quem emprestei" value={debtorName} onChange={e => setDebtorName(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Descrição (opcional)" value={description} onChange={e => setDescription(e.target.value)} fullWidth />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField label="Valor Principal (R$)" type="number" value={principalAmount} onChange={e => setPrincipalAmount(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField label="Taxa de Juros (%)" type="number" value={interestRate} onChange={e => setInterestRate(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField type="date" label="Data de Pagamento" value={dueDate} onChange={e => setDueDate(e.target.value)} fullWidth required InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" fullWidth>Salvar Empréstimo</Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default LoanForm;